import React, { useEffect, useState } from "react";


import { capitalize, size } from "lodash";
import NoDataFound from "../common/NoDataFound";
import Tooltips from "../Tooltips";
import ToolipsCustom from "../ToolipsCustom";

function AboutCompany(props) {

  const data = props.data;
  const cInfo = props.cInfo;
  const hs_codes = props.hs_codes;
  const target_countries = props.target_countries;
  const ports = props.ports;
  const [showNoData, setShowNoData] = useState(true);
  const [noHsCodeData, setNoHsCodeData] = useState(true);
  const [noTargetCountriesData, setNoTargetCountriesData] = useState(true);
  const [noPortData, setNoPortData] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    if (size(data) > 0) {
      setShowNoData(false);
    } else {
      setShowNoData(true);
    }

    if (size(hs_codes) > 0) {
      setNoHsCodeData(false);
    } else {
      setNoHsCodeData(true);
    }

    if (size(target_countries) > 0) {
      setNoTargetCountriesData(false);
    } else {
      setNoTargetCountriesData(true);
    }

    if (size(ports) > 0) {
      setNoPortData(false);
    } else {
      setNoPortData(true);
    }

    if (size(data) <= 0 && size(hs_codes) <= 0 && size(target_countries) <= 0 && size(ports) <= 0) {

    }

  }, [props.data, props.hs_codes, props.target_countries, props.ports]);


  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const capitalizeWords = (str) =>
    str
      .split(" ")
      .map((word) => capitalize(word))
      .join(" ");

  let previewText =  data.about_company;
  if ( data.about_company.length > 1000) {
      previewText = data.about_company.slice(0, 1000);
  }
  return (
    <div className="">
      {!showNoData && (
        <div className="ck-edit-cntnt-block">
          <h3 className="">About Company</h3>
          <p
            className=""
            // dangerouslySetInnerHTML={{ __html: data.about_company }}
            dangerouslySetInnerHTML={{
          __html: isExpanded ? data.about_company : previewText,
        }}
          ></p>
      {
        data.about_company.length > 1000 ? ( 
        <div id="expandbtn" onClick={() => setIsExpanded(!isExpanded)} className="services-read-more-text">
          <i className={isExpanded ? "fa fa-arrow-up" : "fa fa-arrow-down"}></i>
          {isExpanded ? " Read Less" : " Read More..."}
        </div>
          ):""
      }
        </div>
      )}


      <div className="">
        

        {(showNoData && noHsCodeData && noTargetCountriesData && noPortData) && (
          // <p className="text-center no-data-text-color no-data-content">
          //   No Data Found
          // </p>
          <NoDataFound />
        )}

      </div>

    </div>
  );
}

export default AboutCompany;
